import { SistemaInteresseDto } from "src/app/pagamento/models/sistema-interesse-dto";

export const SISTEMA_INTERESSE_DTO_LISTA: SistemaInteresseDto[] = [
  { "codigo": 17, "descricao": "PJ REDE LOCAL" },
  { "codigo": 21, "descricao": "SIEF PROCESSOS" },
  { "codigo": 9, "descricao": "OUTROS INTERESSES" },
];

export const SISTEMA_INTERESSE_DTO_INDICADO: SistemaInteresseDto = { "codigo": 0, "descricao": "" };
